import dayjs from 'dayjs';

/** 1 second in milliseconds */

const SECOND = 1000;
/** 1 minute in milliseconds */

const MINUTE = SECOND * 60;
/** 1 hour in milliseconds */

const HOUR = MINUTE * 60;
/** 24 hours in milliseconds */

const DAY = HOUR * 24;
/** 7 days in milliseconds */

const WEEK = DAY * 7;
const initTimeZoneDate = (timeZone, timestamp) => Object.assign(Object.assign({}, timestamp && {
  timestamp
}), {
  timeZone: timeZone || dayjs.tz.guess()
});
const initDateInfo = () => ({
  dateInstruction: {
    timestamp: undefined,
    timeZone: dayjs.tz.guess()
  }
});

export { DAY, HOUR, MINUTE, SECOND, WEEK, initDateInfo, initTimeZoneDate };
